import { VfSwiper } from '@vfit/shared/atoms';
import { EditorialCard } from '../EditorialCard';
import { useEditorialCardsSwiper } from './editorialCardsSwiper.hook';
import { IEditorialCardsSwiper } from './editorialCardsSwiper.models';
import * as S from './editorialCardsSwiper.style';

export const EditorialCardsSwiper: React.FC<IEditorialCardsSwiper> = ({
  address,
  appointment,
  hideAddress,
  styled,
  title,
}) => {
  const { isMobile, pTitle } = useEditorialCardsSwiper({ title });

  return (
    <S.Container styled={styled}>
      {pTitle && (
        <S.Wrapper>
          <S.Title dangerouslySetInnerHTML={{ __html: pTitle }} />
        </S.Wrapper>
      )}
      {isMobile && !hideAddress ? (
        <VfSwiper
          slideWidth={269}
          freeMode={undefined}
          effect={undefined}
          noSwipingSelector={undefined}
          slidesPerView={undefined}
          centeredSlides={false}
        >
          <EditorialCard.TechAppointmentSummary {...appointment} />
          <EditorialCard.AddressUserData {...address} />
        </VfSwiper>
      ) : (
        <S.CardsWrapper>
          <EditorialCard.TechAppointmentSummary {...appointment} />
          {!hideAddress && <EditorialCard.AddressUserData {...address} />}
        </S.CardsWrapper>
      )}
    </S.Container>
  );
};

